import { ArrowLeftIcon, ArrowRightIcon } from "@chakra-ui/icons";
import {
  Box,
  Button,
  Flex,
  FormControl,
  HStack,
  Image,
  Input,
  InputGroup,
  InputRightElement,
  Select,
  Table,
  TableContainer,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
  useBreakpointValue,
  useDisclosure,
  VStack,
  Wrap,
  WrapItem,
} from "@chakra-ui/react";
import { ChangeEvent, useEffect, useState } from "react";
import { FiFilter } from "react-icons/fi";
import { RiSearch2Line } from "react-icons/ri";
import { NumericFormat } from "react-number-format";
import Pagination from "react-paginate";
import Footer from "../components/common/Footer";
import Header from "../components/common/Header";
import SafeSecure from "../components/common/SafeSecure";
import elect from "../img/elect2.png";
import bgImage from "../img/upcomingTrBG.svg";
import { ICenter } from "../models/centers.model";
import CenterService from "../services/admin/center.service";
import coursesService from "../services/courses.service";
import registrationService from "../services/registration.service";

export const UpcomingTrainings = () => {
  const [gender, setGender] = useState<any[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  // const [courses, setCourses] = useState<ICourse[]>([]);
  const [courses, setCourses] = useState<any[]>([]);
  const [filteredCourses, setFilteredCourses] = useState<any[]>([]);
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [centers, setCenters] = useState<ICenter[]>([]);
  const [selectedCategory, setSelectedCategory] = useState("");
  const [selectedCenter, setSelectedCenter] = useState("");
  const [selectedDuration, setSelectedDuration] = useState("");
  const [selectedCost, setSelectedCost] = useState("");

  const [currentPage, setCurrentPage] = useState(0);
  const [perPage, setPerPage] = useState(10);
  const [showMenu, setShowMenu] = useState(false);
  const hideDropdowns = useBreakpointValue({ base: true, lg: false });

  const categories = [
    {
      id: "1",
      title: "TECHNICAL COURSE",
    },
    {
      id: "2",
      title: "NON-TECHNICAL COURSE",
    },
  ];

  const duration = [
    {
      id: "1",
      title: "Days",
    },
    {
      id: "2",
      title: "Weeks",
    },
    {
      id: "3",
      title: "Months",
    },
  ];

  const cost = [
    {
      id: "1",
      title: "Highest to Lowest",
    },
    {
      id: "2",
      title: "Lowest to Highest",
    },
  ];

  useEffect(() => {
    CenterService.getCenters(`?category=rtc`)
      .then((response) => {
        setCenters(response.data.data);
      })
      .catch((err) => err);
  }, []);

  useEffect(() => {
    const url22 = `?filter=upcoming-course`;
    registrationService
      .getAllUpcomingCourses(url22)
      .then((response) => {
        // const courses_response = response.map((course: any) => course.course);
        const courses_response = response.map((courseData: any) => {
          return {
            ...courseData.course,
            training_start: courseData.training_start, // Assuming training_start is directly within courseData
          };
        });
        setCourses(courses_response);
        setFilteredCourses(courses_response);
        setIsLoading(false);
      })
      .catch((err) => err);

    const maingender = [
      {
        id: "1",
        title: "Technical",
      },
      {
        id: "2",
        title: "Non-Technical",
      },
    ];
    setGender(maingender);
  }, []);

  const currentItems = filteredCourses.slice(
    currentPage * perPage,
    (currentPage + 1) * perPage
  );

  const handlePageChange = (page: any) => {
    setCurrentPage(page.selected);
  };

  const handleSearchChange = (event: ChangeEvent<HTMLInputElement>) => {
    const searchTerm = event.target.value.toLowerCase();

    const filtered = courses?.filter((each) =>
      each.name.toLowerCase().includes(searchTerm)
    );
    setFilteredCourses(filtered);
  };

  const filterCourses = () => {
    let filtered = courses;

    // Filter by category
    if (selectedCategory) {
      console.log(selectedCategory, "selectedCategory");
      filtered = filtered.filter(
        (course) => course.category?.name === selectedCategory
      );
    }

    // Filter by duration
    if (selectedDuration) {
      filtered = filtered.filter(
        (course) => course.duration_unit === selectedDuration
      );
    }

    // Sort courses by cost
    if (selectedCost) {
      filtered.sort((courseA, courseB) => {
        const costA = courseA.cost;
        const costB = courseB.cost;
        if (selectedCost === "Lowest to Highest") {
          return costA - costB;
        } else if (selectedCost === "Highest to Lowest") {
          return costB - costA;
        }
        return 0;
      });
    }

    // Filter by center
    if (selectedCenter) {
      filtered = filtered.filter((course) =>
        course.centres.some((centre: any) => centre.name === selectedCenter)
      );
    }

    setFilteredCourses(filtered);
  };

  useEffect(() => {
    filterCourses();
  }, [selectedCategory, selectedDuration, selectedCost, selectedCenter]);

  return (
    <>
      <Header />
      <Box width="100%">
        <Box
          bgImage={bgImage}
          bgRepeat="no-repeat"
          objectFit="cover"
          bgSize="cover"
          pt={["30px", "72px"]}
        >
          <Box pt="80px" px="5%" pb="50px">
            <Text
              fontSize={["40px", "48px"]}
              color="white"
              fontWeight="800"
              textAlign="left"
            >
              Upcoming Training and Courses <br></br> Schedule
            </Text>
            <Text
              mt="25px"
              fontSize={["16px", "22px"]}
              textAlign="left"
              fontWeight="400"
              color="white"
            >
              Various Training Programs and Courses are scheduled to <br></br>
              take place in our Training Centres all year round.<br></br>
              Avail yourself the rare opportunity of being trained as a{" "}
              <br></br>professional in the power sector.
            </Text>
          </Box>
        </Box>
        <Flex
          py="55px"
          px={["20px", "30px"]}
          justifyContent="space-between"
          flexDirection={["column", "column", "row", "row"]}
          gap="1rem"
        >
          <InputGroup
            color="brand.subtitle"
            bg="white"
            width={["100%", "100%", "75%", "30"]}
            display={"flex"}
          >
            <Input
              height="50px"
              placeholder="Search for training"
              fontSize={12}
              size="sm"
              onChange={(e) => handleSearchChange(e)}
            />

            <InputRightElement
              // h="1.9rem"
              pointerEvents="none"
              children={<RiSearch2Line size="0.9rem" />}
            />
          </InputGroup>

          {/* mobile menu */}
          {hideDropdowns && (
            <Box width={["100%", "100%", "35%", "35%"]} position={"relative"}>
              <Button
                leftIcon={<FiFilter />}
                bg="white"
                width={"100%"}
                height={"50px"}
                border={"1px solid #9E9E9E"}
                borderRadius={"none"}
                onClick={() => setShowMenu(!showMenu)}
                transition={"all 0.3s"}
              >
                Filter by{" "}
              </Button>
              {showMenu && (
                <VStack
                  spacing="30px"
                  bg="white"
                  p="1rem"
                  position={"absolute"}
                  zIndex={"1000"}
                  width={"100%"}
                  boxSizing="border-box"
                  border={"0.5px solid #9E9E9E"}
                  transition={"all 0.5s ease-in"}
                  height={showMenu ? "auto" : "0"}
                  opacity={showMenu ? 1 : 0}
                >
                  <FormControl position={"relative"}>
                    <Select
                      width="100%"
                      height="50px"
                      variant="outline"
                      bg="inputText.500"
                      size="sm"
                      fontSize={12}
                      placeholder="Category"
                      value={selectedCategory}
                      name="categories"
                      color="brand.subtitle"
                      onChange={(e) => setSelectedCategory(e.target.value)}
                    >
                      {categories.map((each) => (
                        <option key={each.id} value={each.title}>
                          {" "}
                          {each.title}{" "}
                        </option>
                      ))}
                    </Select>
                  </FormControl>

                  <FormControl>
                    <Select
                      height="50px"
                      width="100%"
                      variant="outline"
                      bg="inputText.500"
                      size="sm"
                      fontSize={12}
                      placeholder="Centers"
                      value={selectedCenter}
                      name="centers"
                      color="brand.subtitle"
                      onChange={(e) => setSelectedCenter(e.target.value)}
                    >
                      {centers.map((each) => (
                        <option key={each.id} value={each.name}>
                          {" "}
                          {each.name}{" "}
                        </option>
                      ))}
                    </Select>
                  </FormControl>

                  <FormControl>
                    <Select
                      height="50px"
                      width="100%"
                      variant="outline"
                      bg="inputText.500"
                      size="sm"
                      fontSize={12}
                      placeholder="Duration"
                      value={selectedDuration}
                      name="duration"
                      color="brand.subtitle"
                      onChange={(e) => setSelectedDuration(e.target.value)}
                    >
                      {duration.map((each) => (
                        <option key={each.id} value={each.title}>
                          {" "}
                          {each.title}{" "}
                        </option>
                      ))}
                    </Select>
                  </FormControl>
                  <FormControl>
                    <Select
                      height="50px"
                      width="100%"
                      variant="outline"
                      bg="inputText.500"
                      size="sm"
                      fontSize={12}
                      placeholder="Cost"
                      value={selectedCost}
                      name="gender"
                      color="brand.subtitle"
                      onChange={(e) => setSelectedCost(e.target.value)}
                    >
                      {cost.map((each) => (
                        <option key={each.id} value={each.title}>
                          {" "}
                          {each.title}{" "}
                        </option>
                      ))}
                    </Select>
                  </FormControl>
                </VStack>
              )}
            </Box>
          )}

          {!hideDropdowns && (
            <HStack spacing="30px">
              <FormControl>
                <Select
                  width="170px"
                  height="50px"
                  variant="outline"
                  bg="inputText.500"
                  size="sm"
                  fontSize={12}
                  placeholder="Category"
                  value={selectedCategory}
                  name="categories"
                  color="brand.subtitle"
                  onChange={(e) => setSelectedCategory(e.target.value)}
                >
                  {categories.map((each) => (
                    <option key={each.id} value={each.title}>
                      {" "}
                      {each.title}{" "}
                    </option>
                  ))}
                </Select>
              </FormControl>

              <FormControl>
                <Select
                  height="50px"
                  width="170px"
                  variant="outline"
                  bg="inputText.500"
                  size="sm"
                  fontSize={12}
                  placeholder="Centers"
                  value={selectedCenter}
                  name="centers"
                  color="brand.subtitle"
                  onChange={(e) => setSelectedCenter(e.target.value)}
                >
                  {centers.map((each) => (
                    <option key={each.id} value={each.name}>
                      {" "}
                      {each.name}{" "}
                    </option>
                  ))}
                </Select>
              </FormControl>

              <FormControl>
                <Select
                  height="50px"
                  width="170px"
                  variant="outline"
                  bg="inputText.500"
                  size="sm"
                  fontSize={12}
                  placeholder="Duration"
                  value={selectedDuration}
                  name="duration"
                  color="brand.subtitle"
                  onChange={(e) => setSelectedDuration(e.target.value)}
                >
                  {duration.map((each) => (
                    <option key={each.id} value={each.title}>
                      {" "}
                      {each.title}{" "}
                    </option>
                  ))}
                </Select>
              </FormControl>
              <FormControl>
                <Select
                  height="50px"
                  width="170px"
                  variant="outline"
                  bg="inputText.500"
                  size="sm"
                  fontSize={12}
                  placeholder="Cost"
                  value={selectedCost}
                  name="gender"
                  color="brand.subtitle"
                  onChange={(e) => setSelectedCost(e.target.value)}
                >
                  {cost.map((each) => (
                    <option key={each.id} value={each.title}>
                      {" "}
                      {each.title}{" "}
                    </option>
                  ))}
                </Select>
              </FormControl>
            </HStack>
          )}
        </Flex>
      </Box>
      <Flex
        bg="#F9F9F9"
        justifyContent="center"
        alignContent="center"
        width="100%"
        height="auto"
        direction="column"
      >
        <TableContainer bg="white" pb="150px" px="50px" overflowX={"scroll"}>
          <Table variant="simple">
            <Thead>
              <Tr>
                <Th width="600px">Courses</Th>
                <Th>Training Date</Th>
                <Th>Duration</Th>
                <Th>Cost</Th>
              </Tr>
            </Thead>
            <Tbody>
              {currentItems?.map((each: any, index) => (
                <Tr key={index}>
                  <Td width="600px">
                    <HStack
                      cursor="pointer"
                      // onClick={() => viewCourse(each.uuid)}
                    >
                      <Box pt="15px" width="127px" height="107px">
                        <Image
                          src={each?.cover_image ? each?.cover_image : elect}
                          objectFit="cover"
                        />
                      </Box>
                      <Box>
                        <Text
                          fontSize="12px"
                          width="180px"
                          pl="10px"
                          mb="0.5rem"
                          bg={
                            each.category?.name === "TECHNICAL COURSE"
                              ? "#0539BE"
                              : "#579956"
                          }
                          color="white"
                        >
                          {each?.category?.name}
                        </Text>
                        <Text
                          color="#4E4D4D"
                          fontSize="20px"
                          fontWeight="600"
                          mb="0.5rem"
                          width="400px"
                          className="wordWrap"
                          textTransform={"capitalize"}
                        >
                          {each?.name?.toLowerCase()}
                        </Text>
                        <Text
                          color="#4E4D4D"
                          fontSize="13px"
                          fontWeight="400"
                          mb="0.5rem"
                          width="600px"
                          className="wordWrap"
                        >
                          {each.description
                            ? `${each.description.slice(0, 200)}...`
                            : "nil"}
                        </Text>
                        <Text
                          mt={"5px"}
                          color={"#4E4D4D"}
                          fontSize={"11px"}
                          fontWeight={"700"}
                        >
                          Regional Training Centers:
                        </Text>
                        <Wrap width="600px" spacing="20px">
                          {each?.centres &&
                            each?.centres.map((center: any, index: any) => (
                              <WrapItem key={index}>
                                <Text
                                  color="#4E4D4D"
                                  fontSize="13px"
                                  fontWeight="400"
                                  mb="0.5rem"
                                  mt={"5px"}
                                  pr={"15px"}
                                  borderRight={"1px solid lightgray"}
                                >
                                  {`${center.name}- ${center.state}`}
                                </Text>
                              </WrapItem>
                            ))}
                        </Wrap>
                      </Box>
                    </HStack>
                  </Td>
                  <Td>{each?.training_start}</Td>
                  <Td>{`${each?.duration} ${each?.duration_unit}`} </Td>
                  <Td>
                    <Text>
                      <NumericFormat
                        value={each?.cost}
                        displayType={"text"}
                        thousandSeparator={true}
                        prefix={"₦"}
                      />
                    </Text>
                  </Td>
                </Tr>
              ))}
              {currentItems && currentItems.length == 0 && (
                <Box padding={"1.4rem"}>
                  <Text>No courses found</Text>
                </Box>
              )}
            </Tbody>
          </Table>
        </TableContainer>
        {currentItems.length > 0 && !isLoading ? (
          <Box pb="1rem">
            <Pagination
              breakLabel="..."
              nextLabel={<ArrowRightIcon style={{ fontSize: 18 }} />}
              onPageChange={handlePageChange}
              pageRangeDisplayed={5}
              pageCount={Math.ceil(filteredCourses.length / perPage)}
              previousLabel={<ArrowLeftIcon style={{ fontSize: 18 }} />}
              containerClassName="pagination"
              pageLinkClassName="page-num"
              previousLinkClassName="page-num"
              nextLinkClassName="page-num"
              activeLinkClassName="active"
              // renderOnZeroPageCount={null}
            />
          </Box>
        ) : (
          ""
        )}
        <SafeSecure />
      </Flex>
      <Footer />
    </>
  );
};

export default UpcomingTrainings;
